var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"realtime-data"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.resHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }